import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { teamSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import CodeEditor from "../../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../../Components/ImageUploadDragAndDrop";
import Select from "react-select";
import { customStyles } from "../../../utils/constant";

const AddTeam = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    name: editData?.name || "",
    designation: editData?.designation || "",
    image: editData?.image || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive,
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: teamSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();

        formData.append("sortOrder", values.sortOrder);
        formData.append("designation", values.designation);
        formData.append("name", values.name);
        formData.append("isActive", values.isActive || false);
        if (values.image instanceof File) {
          formData.append("image", values.image);
        }

        const response = editingId
          ? await axiosInstance.put(`/team/updateTeam/${editingId}`, formData)
          : await axiosInstance.post("/team/createTeam", formData);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator(`/teams`);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const Type = [
    { label: "LeaderShip", value: "LeaderShip" },
    { label: "Management", value: "Management" },
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Teams", path: "/teams" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Team
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="client-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="client-sortOrder"
                        name="sortOrder"
                        placeholder="Enter client Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="team-name" className="col-form-label ">
                        Member Name
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="team-name"
                        name="name"
                        placeholder="Enter team name"
                        value={values.name || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.name && errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="team-designation"
                        className="col-form-label "
                      >
                        Member Designation
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="team-designation"
                        name="designation"
                        placeholder="Enter team designation"
                        value={values.designation || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.designation && errors.designation && (
                        <small className="text-danger">
                          {errors.designation}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="slider-image"
                      label={`Member Profile (354px X 354px)`}
                      value={values.image}
                      onChange={(file) => setFieldValue("image", file)}
                      error={errors.image}
                      touched={touched.image}
                    />
                  </div>
                  <div className="col-md-6 mt-5">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to={`/teams`}>
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTeam;
